import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d17232d")

_pushScopeId("data-v-4d17232d")
const _hoisted_1 = { class: "\n      bg-white\n      flex flex-col\n      text-12px\n      xxl:text-14px\n      overflow-hidden\n      h-screen\n      relative\n      tab-content\n    " }
const _hoisted_2 = { class: "flex mt-4 tab-container" }
const _hoisted_3 = { class: "tab-item-container" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = { class: "filter-mobile-datepicker" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_advance_filter = _resolveComponent("advance-filter")!
  const _component_DatePickerBottomSheet = _resolveComponent("DatePickerBottomSheet")!
  const _component_OutPackages = _resolveComponent("OutPackages")!
  const _component_InPackages = _resolveComponent("InPackages")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createBlock("div", {
            key: tab.key,
            class: 
            `
            rounded-full
            text-10px
            xxl:text-14px
            py-2
            px-3
            mr-2
            
            ${_ctx.isTabActive(tab.key) ? 'tab-active' : ''}
            cursor-pointer
            tab-item
          `
          ,
            onClick: ($event: any) => (_ctx.changeTab(tab.key))
          }, _toDisplayString(tab.title), 11, ["onClick"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Search, {
          onInput: _ctx.onSearch,
          onClear: _ctx.clearSearch,
          value: _ctx.searchValue,
          placeholder: _ctx.$t('trackDelivery.searchPlaceholderResi'),
          class: "search-filter"
        }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
        _createVNode(_component_TimeRangePicker, {
          class: "mr-2 datepicker",
          onSelect: _ctx.setPeriode,
          ref: "dateRangeFilter",
          advanceStyle: {
            fontSize: 'text-sm'
          },
          maxDate: _ctx.maxDateRange,
          startDate: _ctx.startDate,
          endDate: _ctx.endDate,
          isCloseDateAfterSelect: "",
          showOptions: _ctx.$t('trackDelivery.customToday'),
          isConvertName: true
        }, null, 8, ["onSelect", "maxDate", "startDate", "endDate", "showOptions"]),
        _createVNode(_component_advance_filter, {
          routerName: _ctx.routerName,
          onChange: _ctx.onChangeAdvancedFilter
        }, null, 8, ["routerName", "onChange"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_DatePickerBottomSheet, {
          type: "range-1",
          placeholder: _ctx.$t('placeholderDatePicker'),
          maxDate: _ctx.maxDateRange,
          modelValue: {
            start: _ctx.startDate,
            end: _ctx.endDate
          },
          onChange: _cache[1] || (_cache[1] = (e) => _ctx.setPeriode([e.start, e.end]))
        }, null, 8, ["placeholder", "maxDate", "modelValue"])
      ])
    ]),
    (_ctx.tabKeyActive === 'paket-kiriman-anda')
      ? (_openBlock(), _createBlock(_component_OutPackages, {
          key: 0,
          routerName: _ctx.routerName,
          onFetchDataPackages: _ctx.fetchDataPackages
        }, null, 8, ["routerName", "onFetchDataPackages"]))
      : (_openBlock(), _createBlock(_component_InPackages, {
          key: 1,
          onFetchDataPackages: _ctx.fetchDataPackages
        }, null, 8, ["onFetchDataPackages"]))
  ]))
})